const data = [
  {
    id: 1,
    title: "Encouragement",
    text: `Cindy is a wonder to work with! She's always encouraging,
          keeps in mind your personal fitness level and meets you where
          you are. All while giving you that extra push that you need to
          help you achieve your fitness goals. Highly recommend!  `,
    author: "- Missy",
  },
  {
    id: 2,
    title: "Motivating",
    text: `I can't express enough how much Cindy has helped and motivated
                  me to improve myself. Cindy takes the time to listen to what
                  goals you have and then tailors every workout session to meet
                  those goals with encouragement and positivity.  `,
    author: "- Diane",
  },
  {
    id: 3,
    title: "Restoration",
    text: `I had requested a personal trainer that specialized in lower
                  back and core, and I was so fortunate to be paired with Cindy
                  Giles. She has challenged me to overcome my fear of re-injury
                  and to meet goals that helped me to rebuild strength and
                  restore my confidence.I now enjoy biking, boating, hiking and
                  most recently, yoga!  `,
    author: "- Kelly",
  },
];

export default data;
